import { render } from "./DatasetCardLabelsPopper.vue?vue&type=template&id=25ad884e&scoped=true"
import script from "./DatasetCardLabelsPopper.vue?vue&type=script&lang=js"
export * from "./DatasetCardLabelsPopper.vue?vue&type=script&lang=js"

import "./DatasetCardLabelsPopper.vue?vue&type=style&index=0&id=25ad884e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ad884e"]])

export default __exports__